<template>
    <rkm-overlay>
        <template v-if="[enums.setorTipo.CONSULTORIO].includes(centroCusto.setor.tipoId)">
            <rkm-layout-body title="Atendimento">
                <template v-slot:actions>
                    <rkm-button
                        @click="exit"
                        color="danger"
                    >
                        Sair
                    </rkm-button>

                    <rkm-button
                        :disabled="disableSaveDraftButton"
                        @click="$refs.Form.save(true)"
                        color="info"
                    >
                        Salvar rascunho
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.save()"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>

                <template v-slot:subtitle>
                    <div class="sub-title">
                        <template v-if="!!form">
                            <div>
                                <span v-if="!!form.paciente.nomeSocial">
                                    <strong class="sub-title-nome">{{form.paciente.nomeSocial}} (Nome social)</strong> {{form.paciente.nome}} |
                                </span>

                                <span v-else>
                                    <strong class="sub-title-nome">{{form.paciente.nome}}</strong> |
                                </span>

                                <span>{{form.paciente.sexoDescricao}}</span>
                            </div>

                            <div>
                                <template v-if="form.paciente.dataNascimento">
                                    <span>
                                        {{form.paciente.idadeFormatada}} |
                                    </span>

                                    <span>
                                        Nasceu em {{form.paciente.dataNascimento}}
                                    </span>
                                </template>

                                <span>
                                    <strong>CPF</strong> {{form.paciente.cpf ? form.paciente.cpf : '-'}}
                                </span>

                                <span>
                                    <strong>CNS</strong> {{form.paciente.cns ? form.paciente.cns : '-'}}
                                </span>

                                <span>
                                    <strong>Nome da mãe</strong> {{form.paciente.nomeMae ? form.paciente.nomeMae : '-'}}
                                </span>

                                <span>
                                    <strong>Telefone</strong>&nbsp;

                                    <template v-if="form.paciente.telefoneNumero">
                                        <rkm-button
                                            @click="$refs.ModalPacienteTelefone.open(form.paciente)"
                                            class="sub-title-link"
                                            color="link"
                                            title="Atualizar telefone"
                                        >
                                            {{form.paciente.telefoneNumero}}
                                        </rkm-button>

                                        <template v-if="form.paciente.telefoneNumero.length === 15">
                                            (Autoriza SMS: {{form.paciente.telefoneAutorizaSms ? 'Sim' : 'Não'}})
                                        </template>
                                    </template>

                                    <template v-else>-</template>
                                </span>
                            </div>

                            <div v-if="!!form.usuario.nome">
                                <span>
                                    <strong>Profisional</strong> {{form.usuario.nome}}
                                </span>

                                <span>
                                    <strong>CBO</strong> {{form.usuario.ocupacaoCodigo}}
                                </span>

                                <span>
                                    <strong>Especialidade</strong> {{!!form.usuario.especialidadeNome ? form.usuario.especialidadeNome : '-'}}
                                </span>
                            </div>
                        </template>
                    </div>
                </template>

                <rkm-layout-content :no-card-style="form && !form.paciente.isIdoso">
                    <Form
                        :agendamento-id="agendamentoId"
                        :fila-id="filaId"
                        :ficha-avaliacao="fichaAvaliacao"
                        @loaded="loaded"
                        @saved="saved"
                        ref="Form"
                    />
                </rkm-layout-content>
            </rkm-layout-body>

            <ModalPacienteTelefone ref="ModalPacienteTelefone" />
        </template>

        <template v-else>
            <rkm-layout-body title="Atendimento">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>CONSULTÓRIO</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/ambulatorio/atendimento/Form'
import ModalPacienteTelefone from '@/components/ambulatorio/components/paciente/telefone/Modal'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        Form,
        ModalPacienteTelefone,
    },
    computed: {
        ...mapGetters({centroCusto: 'getCentroCusto'}),
        disableSaveDraftButton() {
            return this.model && (this.model.soap.finalizacao.desfecho.finalizado === true || this.model.soap.finalizacao.desfecho.finalizado === 'encaminhar')
        },
        isRetroativo() {
            return this.filaId === 0
        }
    },
    created() {
        this.setShowExitFormConfirmation()

        this.repositories = {
            fila: this.getConectaSusRepository('ambulatorio.fila'),
        }
    },
    data: () => ({
        enums: {setorTipo},
        additionals: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'setShowExitFormConfirmation',
            'unsetLoading',
            'unsetShowExitFormConfirmation',
        ]),
        redirectToList() {
            this.unsetShowExitFormConfirmation()
            this.$router.push('/ambulatorio/atendimento/index')
        },
        loaded(value) {
            this.additionals = value.additionals
            this.form = value.form
            this.model = value.model

            if(value.form.finalizadoEm){
                this.redirectToList()
            }
        },
        saved() {
            this.redirectToList()
        },
        exit() {
            this.showExitConfirmation(async () => {
                if (this.isRetroativo || this.additionals.isRascunho) {
                    this.redirectToList()
                } else {
                    this.setLoading()

                    return this.repositories.fila.sendBack(this.filaId)
                        .then(() => this.redirectToList())
                        .finally(() => this.unsetLoading())
                }
            }, this.handleError)
        },
    },
    mixins: [error, repository],
    props: {
        filaId: {type: Number, required: true},
        agendamentoId: {type: Number},
        fichaAvaliacao: {type: Boolean, default: true},
    },
}
</script>

<style scoped>
.sub-title {
    color: #222;
    font-size: 14px;
    text-transform: none !important;
}
.sub-title-link {
    font-size: 14px;
    text-transform: none !important;
    text-align: top;
    height: auto;
    margin-bottom: 3px;
    padding: 0;
}
.sub-title-nome {
    font-size: 18px;
}
</style>